module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19meFZU/tc-custom/9781439676417.jpg?1702530412155",
      "alt": "This image is the cover for the book LeDroit Park, History & Guide"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("LeDroit Park, History & Guide\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Built as a gated, all-white community, in the 20th century LeDroit Park became the premier neighborhood of Washington, DC's Black elite.")])]), _c('p', [_vm._v("LeDroit Park's famed arch offers entry into a tree-lined neighborhood with unique architecture and a captivating history. Developed in 1873 by a Howard University trustee who refused to sell lots to Black Washingtonians, the neighborhood was designed to be both town and country, one of DC's earliest suburbs. Not long after the fences of this gated community were torn down, the demographics changed as members of the Black elite of Washington moved there. During the 20th century it was home to educators and activists, military men and artists, doctors and scientists - both white and Black, men and women.")]), _c('p', [_vm._v("Local historian and guide Canden Schwantes leads you through this neighborhood, small in size but large in history, to discover the stories of the people who called LeDroit Park home.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Canden Schwantes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Canden Schwantes (now Arciniega) has been a historian and tour guide in Washington, D.C., for more than a decade. She has published three other books about D.C. history, as well as numerous articles. She has been featured on the Travel Channel, Discovery Channel, BBC, NPR and local news discussing D.C. history and tourism. Her company, Free Tours by Foot, operates worldwide, but her home and heart is in D.C.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0